// extracted by mini-css-extract-plugin
export default {"legal-consent":"legal-consent__25CY1"};